lectureData = -> $("#lecture_heading").data()

coursePath = -> location.pathname.split("lectures/")[0]

setLoadingUrl = (string) ->
  document.getElementById("lecture_complete_button").dataset.loadingUrl = string
  return

fetchLoadingUrl = ->
  return document.getElementById("lecture_complete_button").dataset.loadingUrl

markAsComplete = ->
  user = currentUser()
  deferred = $.Deferred()
  if fetchLoadingUrl() != completionUrl()
    setLoadingUrl(completionUrl())
    if user?.id
      markAsCompleteInSidebar()
      updateCompletion(percentComplete())
      $.ajax({ url: completionUrl(), data: {}, method: "POST", headers: { "X-CSRF-Token": $( 'meta[name="csrf-token"]' ).attr( 'content' ) } }).done (data) ->
        deferred.resolve(data)
    else
      deferred.resolve({percent_complete: 0})

    window.trackEvent("Curriculum: Lecture Complete", {
      lectureUrl: window?.lecture_data?.lectureUrl || undefined,
      lectureId: window?.lecture_data?.lectureId || undefined
    })

    if percentComplete()?.toString() == '100'
      window.trackEvent("Curriculum: Course Complete", {
        courseId: window?.course_params?.friendlyUrl || undefined
      })

    return deferred.promise()
  else
    return false

getNextLectureUrl = ->
  item = $("li.next-lecture").next().data()
  if item
    item.lectureUrl
  else
    # next lecture section first item
    item = $("li.next-lecture").parent().parent().next().find("li")[0]
    if item
      $(item).data().lectureUrl
    else
      false

getPreviousLectureUrl = ->
  item = $("li.next-lecture").prev().data()

  if item
    item.lectureUrl
  else
    # next lecture section first item
    item = $("li.next-lecture").parent().parent().prev().find("li").last()
    if item
      $(item).data().lectureUrl
    else
      location.pathname

isLoggedInOwner = ->
  data = document.getElementById('fedora-data')
  roleAttribute = data && data.dataset && data.dataset.role
  previewAttribute = data && data.dataset && data.dataset.preview
  return roleAttribute == 'owner' && previewAttribute == 'logged_in'

setupCourseComplianceLecturePage = ->
  if $('#lecture-completion-data').data().validForCompletion || isLoggedInOwner()
    $('#lecture_complete_button').removeClass('disabled')
  else
    $('#lecture_complete_button').addClass('disabled')
  return

setupCourseComplianceSidebar = ->
  $('.course-section').each ->
    sectionData = $(this).find('.section-title').data()
    items = $(this).find("li[data-lecture-id]")
    completedItems = $(this).find("li.unlocked-lecture")
    if $("#lecture-completion-data") && $("#lecture-completion-data")?.data()?.lastLectureId
      inProgressItems = $(this).find("li[data-lecture-id=" + $("#lecture-completion-data").data().lastLectureId + "]")
    if inProgressItems && inProgressItems.length > 0 && !$(this).find(".section-title").data().daysUntilDripped
      $(inProgressItems[0]).addClass('current-item')
    if completedItems.length < items.length
      $(this).addClass("progress-locked")
      if completedItems.length > 0 || $(this).find(".current-item").length > 0
        $(this).find(".section-lock").addClass("hidden")
    else
      $(this).removeClass("course-section-locked")

  return

courseComplianceEnabled = ->
  return fedora_user.accessibleFeatures.indexOf("course_compliance") != -1

lectureOrderEnforced = ->
  return fedora_user?.courseData?.is_lecture_order_enforced?.toString() == "true"

ready = ->
  return unless location.pathname.indexOf("/lectures/") || location.pathname.indexOf("/comments/")
  # iterate over completed lectures to update CSS of sidebar items (complete vs incomplete)
  currentUser()?.completedLectureIds.forEach((lectureId) ->
    $('.section-item[data-lecture-id="' + lectureId + '"]')
      .addClass('unlocked-lecture')
  )

  setupCourseComplianceSidebar() if courseComplianceEnabled() && lectureOrderEnforced()

  $(".section-item[data-completed]").each ->
    $(this)
      .addClass("completed")
      .removeClass("incomplete")
      .removeClass("next-lecture")

  if onLecturePage()
    setUpLecturePage()

    # check to see if "Previous Button" should be hidden
    renderPreviousButton()

    $("#lecture_complete_button").click (evt) ->
      if (evt.currentTarget.className.indexOf('disabled') == -1)
        evt.preventDefault()
        nextLectureUrl = getNextLectureUrl()

        options = {}

        markAsComplete().then (data) ->
          if data != false
            if nextLectureUrl
              handleLectureLinkClickEvent(evt,nextLectureUrl)
            else if data.url
              document.location.href = data.url
            else
              document.location.href = coursePath() + "?completed_lecture=true"

    $("#lecture_previous_button").click (evt) ->
      if (evt.currentTarget.className.indexOf('disabled') == -1)
        previousLectureUrl = getPreviousLectureUrl()
        evt.preventDefault()
        if previousLectureUrl
          handleLectureLinkClickEvent(evt, previousLectureUrl).then ->
            setLoadingUrl("")

    $(".item").click (evt) ->
      handleLectureLinkClickEvent(evt, evt.currentTarget.href).then ->
        setLoadingUrl("")
  return

renderPreviousButton = ->
  # if first lecture is selected, hide "Previous Lecture" button
  # yes, one day we will not have to rely on the DOM to store this state
  if $('.section-item').first().hasClass('next-lecture')
    $('#lecture_previous_button').hide()
  else
    $('#lecture_previous_button').show()

updatePDFViewerHeight = ->
  $(".pdf-viewer").height($(window).height() - 200) if $(".pdf-viewer").length > 0
  return

setupLastLectureButton = ->
  if currentUser()?.id && currentUser()?.courseIds.indexOf(fedora_user.id) != -1
    $("#last_lecture_button").attr("href", $("#lecture-completion-data").data().lastLectureUrl)

setUpLecturePage = ->
  window.lecture_data = lectureData()
  Wistia.reinitialize()
  updateSideBarCompletions()
  updateLectureData()
  setupComments()
  setupLastLectureButton()
  $(".course-sidebar").scroll ->
    stickyProgressBar()
  return

window.updateDisqus = ->
  updateCurrentLectureHighlight() if !onBlogPage()
  disqusData = $("#disqus_data").data()

  if disqusData and DISQUS?
    DISQUS.reset
      reload: true
      config: ->
        @page.url = if disqusData.url is "" then undefined else disqusData.url
        @page.identifier = if disqusData.identifier is "" then undefined else disqusData.identifier
        return
  else
    try
      DISQUS.reset
    catch

completionUrl = ->
  lecture_data.lectureUrl + "/complete"

postCompletionStatus = ->
  $.ajax({ url: completionUrl(), data: {}, method: "POST", headers: { "X-CSRF-Token": $( 'meta[name="csrf-token"]' ).attr( 'content' ) } })

percentComplete = ->
  ($(".section-item.completed").length / $(".section-item").length * 100).toFixed()

updateCompletion = (percent) ->
  $(".progressbar-fill").attr("style","min-width:#{percent}%;")
  $(".percentage").text("#{percent}%")

updateLectureData = ->
  updateCurrentLectureHighlight()
  updateSideBarCompletions()
  if location.pathname.indexOf("/comments/") == -1
    state_object = {id: lectureData().lectureId, name: "lecture"}
    history.pushState(state_object,"", state_object.id.toString() + window.location.hash)
  updatePDFViewerHeight()
  collapseResponsiveSidebar()
  if fedora_user?.dripEnabled
    setupDrip()

lectureSidebarLink = (id) ->
 $("#sidebar_link_#{id}")

collapseResponsiveSidebar = ->
  $(".nav-icon-list").addClass("collapsed")
  $(".course-sidebar").attr("aria-expanded", "false").removeClass("in")

lectureSidebarSection = (id) ->
  $("#sidebar_link_#{id}").parent()

markLectureAsCompleteInSidebar = (id) ->
  lectureSidebarSection(id).addClass("completed").removeClass("incomplete")

markAsCompleteInSidebar = ->
  markLectureAsCompleteInSidebar(lectureData().lectureId)

updateSideBarCompletions = ->
  currentUser().completedLectureIds.forEach((id) -> markLectureAsCompleteInSidebar(id))

lectureSidebarHeaderHeight = ->
  parseInt($(".course-progress.lecture-page").outerHeight() + 5)

window.updateCurrentLectureHighlight = ->
  $(".section-item").removeClass("next-lecture")
  setLabelsForCompleted()
  window.lecture_data = lectureData()
  lectureSidebarSection(lecture_data.lectureId).addClass("next-lecture")
  setLabelForCurrent()
  myContainer = $('.course-sidebar')
  if $(".next-lecture").length
    nextLectureTop = $(".next-lecture").offset().top
    myContainerTop = myContainer.offset().top
    myContainerScrollTop = myContainer.scrollTop()
    myContainer.animate
      scrollTop: nextLectureTop - myContainerTop + myContainerScrollTop - lectureSidebarHeaderHeight()

handleLectureLinkClickEvent = (event, url) ->
  if url
    event.preventDefault()
    getPageWithoutLayout(url).then (response) ->
      successEvent = new Event("lecture:ajax_success", {"bubbles": true, "cancelable": false})
      document.dispatchEvent(successEvent)
      return
  else
    return true

getPageWithoutLayout = (url) ->
  lectureContentsPromise = $.ajax({ url: "#{url}?layout=false", method: "GET", headers: { "X-CSRF-Token": $( 'meta[name="csrf-token"]' ).attr( 'content' ) } })
  lectureContentsPromise.done(updateWithNewLecturePartial)
  lectureContentsPromise

updatePageTitle = ->
  lectureName = $(".lecture-content").find("h2").text().trim()
  titleParts = document.title.split("|")
  schoolName = if titleParts[1] then " | #{titleParts[1].trim()}" else ""
  pageTitle = "#{lectureName}#{schoolName}"
  document.title = pageTitle
  return

updateWithNewLecturePartial = (data) ->
  if window.removeWistiaVideos
    window.removeWistiaVideos()
  $(".lecture-content").replaceWith(data)
  $("html, body").animate({ scrollTop: 0 }, "fast")
  updateLectureData()
  setupComments()
  $("#comments_wrapper").innerHTML = ""
  updateCurrentLectureHighlight()
  updatePageTitle()
  setupLastLectureButton()
  $(document).trigger('lecture:change')
  document.dispatchEvent(new Event('lecture:change'))
  # check to see if "Previous Button" should be hidden
  renderPreviousButton()
  if courseComplianceEnabled() && lectureOrderEnforced()
    setupCourseComplianceLecturePage()
    setupCourseComplianceSidebar()
  return

setupComments = ->
  window.resetCommentData()
  window.setCommentData()
  window.loadCommentsPage(1)
  window.setupCommentHandlers()

# Detection Methods
onBlogPage = ->
  document.URL.indexOf('/blog') isnt -1

onLecturePage = ->
  document.URL.indexOf('/lectures/') isnt -1

# Sticky progress bar in the lecture sidebar
stickyProgressBar = ->
  stickySidebarPadding = parseInt($(".course-progress.lecture-page").outerHeight() + 5)
  sidebarMinimumScroll = $(".course-sidebar h2").height() + 25 + $(window).height()

  if $(".course-sidebar").scrollTop() + $(window).height() > sidebarMinimumScroll
    $(".course-progress.lecture-page").removeClass("is-at-top").addClass "sticky"
    $(".course-sidebar.lecture-page h2").attr('style', 'padding-bottom: ' + stickySidebarPadding + 'px')
  else
    $(".course-sidebar.lecture-page h2").attr('style', 'padding-bottom: 0px')
    $(".course-progress.lecture-page").addClass("is-at-top").removeClass "sticky"
  return

setLabelsForCompleted = ->
  $(".section-item .status-container").removeAttr('aria-label')
  $(".section-item.completed .status-container").attr('aria-label', 'Completed item')

setLabelForCurrent = ->
  $(".section-item.next-lecture .status-container").attr('aria-label', 'Current item')

$(document).on("ready page:load", ready)
